// src/Pages/Reservation.js
import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

import Navbar from "../components/Navbar";
import SecondaryHero from "../components/SecondaryHero";
import ReservationSection from "../components/ReservationSection";
import Footer from "../components/Footer";

const Reservation = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const selectedType = queryParams.get("type");

  return (
    <>
      <Helmet>
        <title>Future Reservation | VisionBird</title>
        <meta
          name="description"
          content="Reserve your future interview slot at VisionBird Technologies. Choose from 3-month unpaid internship, 6-month paid internship (PSEB), or permanent job positions."
        />
        <meta
          name="keywords"
          content="future reservation, internship Pakistan, PSEB internship, permanent job, interview booking"
        />
      </Helmet>

      <Navbar />

      <SecondaryHero
        title="Plan Your"
        titleLast="Future"
        highlight="Career"
        description="Whether you're looking for an internship to gain experience or a permanent position to grow your career, book your interview slot today and take the first step toward your future."
        image="/assets/Images/Resume-pana 1.png"
      />

      <ReservationSection />

      <Footer />
    </>
  );
};

export default Reservation;